
































































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import {
  Representative,
  TaskDetailParam,
} from '@/@types/LibraryComponent';

@Component({
  components: {
    AccountIcon,
    CommonButton,
  },
})
export default class PersonMenu extends Vue {
  @Prop({ default: null })
  private readonly taskId!: number | null;
  @Prop()
  public name!: string | null;
  @Prop()
  private attribute!: string;
  @Prop()
  public iconSize!: number;
  @Prop()
  public avatarSize!: number;
  @Prop()
  public iconColor!: string;
  @Prop()
  public representatives!: Representative[];
  @Prop()
  public avatarColor!: string;
  @Prop({ default: false })
  private customFlag!: boolean;
  private displayName: string | null = '';

  @Prop()
  public isTaskDetailModal!: boolean;

  @Emit('emitTaskData')
  private emitTaskData(
    accountId: number,
    accountName: string
  ): TaskDetailParam {
    const personId = accountId !== 0 ? accountId : null;
    this.displayName = accountName;
    this.closeOnPersonClick = true;
    return {
      taskId: this.taskId,
      value: personId,
      attributeKey: this.attribute,
      customFlag: this.customFlag,
    };
  }

  private mounted() {
    this.displayName = this.name;
  }

  private closeOnPersonClick: boolean = false;
  private personText: string = '';

  // クリックした際モーダルが開いたままにする
  private isClosePersonMenu(): void {
    this.closeOnPersonClick = true;
  }
  // クリックした際モーダルが閉じる
  private isKeepingOpenPersonMenu(): void {
    this.closeOnPersonClick = false;
  }
  // 選択した名前に変更
  private onChangePerson() {
    const person = this.representatives.find((member) => {
      return member.accountName === this.personText;
    });
    if (person != null) {
      this.isClosePersonMenu();
      this.emitTaskData(person.accountId, person.accountName);
      this.personText = '';
    } else return;
  }

  // 入力した名前に変更
  private onUpdatePersonText(personText: string) {
    this.name = personText;
    this.closeOnPersonClick = true;
  }
}
